export enum NotificationMethodEnum {
  PUSH_NOTIFICATION = "push_notification",
  SMS = "sms",
  WHATSAPP = "whatsapp",
  EMAIL = "email",
}
